import type { ComponentCommonProps, Media, Theme } from '../../types/props.js'

export interface MediaSceneSwitcherItem {
  id: string
  title: string
  description?: string
  tag?: string
  videoUrl?: Media | null
  imageUrl?: Media | null
  mobVideoUrl?: Media | null
  mobImageUrl?: Media | null
}

export interface MediaSceneSwitcherProps extends ComponentCommonProps {
  data: {
    titleIcon?: Media
    title?: string
    subtitle?: string
    items?: MediaSceneSwitcherItem[]
    /** 主题，默认 light */
    theme?: Theme
    layout?: 'left' | 'right'
  }
}
